<div class="card hover-show w-100" [ngClass]="isMuted() || isResolved() ? 'text-muted' : ''">
    <ng-container *ngIf="selecting">
        <div class="form-check form-switch position-absolute top-0 start-0 ms-2 mt-2">
            <input class="form-check-input mt-0" [(ngModel)]="alertEntity['selected']"
                   (ngModelChange)="toggleSelectedItem($event)" type="checkbox">
        </div>
    </ng-container>
    <div class="card-body">
        <div class="row gx-3">
            <div class="col-auto notranslate d-flex align-items-center justify-content-between">
                <ng-container *ngIf="getAlertStatusConfig() as config">
                    <span class="h2 m-0" [ngClass]="'text-'+config.colorClass">
                        <i class="bi" [ngClass]="config.icon"></i>
                    </span>
                </ng-container>
            </div>
            <div class="col">
                <div class="row gx-3 mb-1">
                    <ng-container *ngIf="alertEntity.entity?.location as location else noLocationHeader">
                        <div class="col-auto">
                            <a class="h3 notranslate hover-underline text-black" [href]="getLocationDashboardLink()">
                                {{ refDataUtils.locationsFormatter(alertEntity.entity.location) }}
                            </a>
                        </div>
                        <div *ngIf="alert.details.message" class="col-auto text-truncate notranslate"
                             [style.max-width.px]="200"
                             data-bs-toggle="tooltip" data-bs-placement="top" [title]="alert.details.message">
                            <span>{{ alert.details.message }}</span>
                        </div>
                    </ng-container>
                    <ng-template #noLocationHeader>
                        <div class="col-auto">
                            <ng-container *ngIf="alert.details.message else emptyAlert">
                                <span class="h3 notranslate">{{ alert.details.message }}</span>
                            </ng-container>
                            <ng-template #emptyAlert>
                                <span class="h3">No connection found, connection might be removed</span>
                            </ng-template>
                        </div>
                    </ng-template>
                    <div class="col-auto">
                        <span class="badge rounded-pill"
                              [ngClass]="('text-bg-'+badgeColorForAlertType()) + (alert.alertStatus === 'MUTED' ? ' opacity-25 ' : '')">
                            {{ alert.details.type }}
                        </span>
                    </div>
                </div>
                <div class="row gx-3 fs-5">
                    <div class="row col notranslate gx-3">
                        <div class="col-auto" *ngIf="alertEntity.entity as entity">
                            <app-connection-image
                                    [connectionType]="entity.connection.info.connectionType"></app-connection-image>
                            <span class="text-muted">{{ entity.connection.info.code }}</span>
                            <ng-container *ngIf="entity.meter as meter">
                                <ng-container *ngIf="meter.info.type !== 'PRIMARY' && meter.info.type as meterType">
                                    <img [src]="appContext.meterImage(meterType)" class="ms-3 me-2"
                                         [alt]="appContext.meterName(meterType)" [width]="20/1.2">
                                    <span class="text-muted">{{ refDataUtils.meterFormatter(entity) }}</span>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="col-auto text-muted">
                            <span class="bi bi-clock me-2"></span>
                            <span>{{ formatTimestamp(alert.timestamp) }}</span>
                        </div>
                        <div *ngIf="isMuted()" class="col-auto text-muted">
                            <span class="bi bi-volume-mute me-2"></span>
                            <span>{{ formatTimestamp(alert.muteDeadline) }}</span>
                        </div>
                        <div *ngIf="alert.assigneeId" class="col-auto text-muted">
                            <i class="bi bi-person-fill me-1"></i>
                            <span>{{ assigneeName }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto ms-auto mt-n3 me-n3 d-flex align-items-start gap-2">
                <div [class.d-none]="!hasNote(alert)" #tooltipRef class="d-flex align-items-center notranslate" data-bs-toggle="tooltip" data-bs-placement="top">
                    <button type="button" class="btn text-body" style="pointer-events: none; cursor: default;">
                        <i class="bi bi-chat-dots text-body"></i>
                    </button>
                </div>
                <div *ngIf="alertEntity.entity?.location" class="d-flex align-items-center notranslate" data-bs-toggle="tooltip" data-bs-placement="top">
                    <button type="button" class="btn text-body" (click)="openConnectionGraph()" style="cursor: hand;">
                        <i class="bi bi-bar-chart-line"></i>
                    </button>
                </div>
                <div *ngIf="!isResolved() else reopenAlert">
                    <button type="button" class="btn text-body" role="button" data-bs-toggle="dropdown"
                            data-bs-auto-close="outside" aria-expanded="false">
                        <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <button class="dropdown-item" (click)="openResolveAlertModal()">
                                <i class="bi bi-check-circle me-2 text-success"></i> Resolve alert
                            </button>
                        </li>
                        <li *ngIf="isMuted() else unmutedAlert">
                            <button class="dropdown-item" (click)="openUnmuteAlertModal()">
                                <i class="bi bi-volume-up me-2 text-primary"></i> Unmute alert</button>
                        </li>
                        <hr/>
                        <li>
                            <button class="dropdown-item" (click)="updateNote()">
                                <i class="bi bi-pencil-square me-2"></i>
                                {{ alert.note?.trim() ? 'Edit note' : 'Add note' }}
                            </button>
                        </li>
                        <li *ngIf="alert.note?.trim()">
                            <button class="dropdown-item" (click)="openDeleteNoteModal()">
                                <i class="bi bi-trash me-2"></i> Delete note
                            </button>
                        </li>
                        <li>
                            <button class="dropdown-item" (click)="assignUser()">
                                <i class="bi bi-person-plus me-2 text-secondary"></i>
                                {{ alert.assigneeId ? 'Manage user' : 'Assign user' }}
                            </button>
                        </li>
                        <li *ngIf="alert.assigneeId">
                            <button class="dropdown-item" (click)="openRemoveUserModal()">
                                <i class="bi bi-trash me-2"></i> Remove user
                            </button>
                        </li>
                        <ng-template #unmutedAlert>
                            <li>
                                <button class="dropdown-item" (click)="openMuteAlertModal()">
                                    <i class="bi bi-volume-mute me-2 text-muted"></i> Mute alert
                                </button>
                            </li>
                        </ng-template>
                    </ul>
                </div>
                <ng-template #reopenAlert>
                    <div>
                        <button type="button" class="btn text-body" role="button" data-bs-toggle="dropdown"
                                data-bs-auto-close="outside" aria-expanded="false">
                            <i class="bi bi-three-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                            <li>
                                <button class="dropdown-item" (click)="openReopenAlertModal()">
                                <i class="bi bi-arrow-counterclockwise me-2 text-primary"></i> Reopen alert
                                </button>
                            </li>
                        </ul>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>


<ng-template #muteAlertTemplate>
    <p>Are you sure you want to mute this alert?</p>
    <app-form-field label="Mute deadline">
        <app-date-field [(ngModel)]="muteDate" [minDate]="tomorrow()"></app-date-field>
    </app-form-field>
</ng-template>